import React from 'react'
import { Link } from 'react-router-dom'
import { Column, Row } from '@zera-admin/page'
import Avatar from '@zera-admin/avatar'
import Icon from '@zera-admin/icon'

import { TwitterProfileProps } from './types'

const TwitterProfile: React.FunctionComponent<TwitterProfileProps> = (
  props
) => {
  const { data } = props

  return data ? (
    <Row
      style={{
        marginTop: 50,
        marginBottom: 50,
        paddingBottom: 15,
      }}
    >
      <Column
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        xs={{ size: 3 }}
      >
        <Link
          to={{ pathname: `https://twitter.com/${data?.ScreenName}` }}
          target="_blank"
        >
          <Avatar size="xlarge" src={data?.ProfileImageUrl} />
        </Link>
      </Column>
      <Column xs={{ size: 9 }}>
        <Row xs={{ direction: 'row', justify: 'between' }}>
          <Column xs={{ size: 12 }}>
            <Link
              style={{ textDecorationLine: 'none', color: '#000' }}
              to={{ pathname: `https://twitter.com/${data?.ScreenName}` }}
              target="_blank"
            >
              <b>
                {data?.Name}{' '}
                <span>
                  {data?.Verified === true ? (
                    <Icon name="check-circle-outline" />
                  ) : data?.Protected === true ? (
                    <Icon name="lock" />
                  ) : null}
                </span>
              </b>
            </Link>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Kullanıcı adı</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>{data?.ScreenName}</p>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Takipçi sayısı</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>{data?.FollowersCount?.toLocaleString()}</p>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Konum</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>{data?.Location ? data.Location : 'Konum bulunamadı'}</p>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Arkadaş sayısı</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>{data?.FriendsCount?.toLocaleString()}</p>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Hesabı oluşturma tarihi</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>
              {new Date(
                data?.CreatedAt?.toLocaleString() as string
              ).toLocaleString()}
            </p>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Favori sayısı</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>{data?.FavoritesCount?.toLocaleString()}</p>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Doğrulanmış hesap</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>{data?.Verified === false ? 'Doğrulanmadı' : 'Doğrulandı'}</p>
          </Column>
          <Column xs={{ size: 3 }}>
            <b>Post sayısı</b>
          </Column>
          <Column xs={{ size: 3 }}>
            <p>{data?.StatusesCount?.toLocaleString()}</p>
          </Column>
          {data?.Description && (
            <Column xs={{ size: 12 }}>
              <h5>
                Açıklama
                <span style={{ fontWeight: 'lighter' }}>
                  {' '}
                  {data?.Description}
                </span>
              </h5>{' '}
            </Column>
          )}
        </Row>
      </Column>
    </Row>
  ) : null
}

export default TwitterProfile
